<template>
    <div v-if="treeItem.opened">
        <div class="gamesm-category-box" v-for="child in treeItem.children" :key="child.treeItemId">
            <div class="gamesm-category-content" @click="goTo(child.treeItemId)" >
                <div class="gamesm-content-left">
                    <div class="gamesm-text small">{{child.name}} ({{countOutrights(child)}})</div>
                </div>
                <div class="gamesm-content-right" v-if="child.children.length" @click.stop="updateTreeItem(child.treeItemId)">
                    <span class="gamesm-arrow" :class="child.opened ? 'is-selected' : ''" />
                </div>
            </div>
            <template v-if="child.opened" >
                <div v-for="grandchild in child.children" :key="grandchild.treeItemId" class="gamesm-tour-box" @click="goTo(`${child.treeItemId},${grandchild.treeItemId}`)" >
                    <div class="gamesm-content-left">
                        <div class="gamesm-text small">{{grandchild.name}} ({{countOutrights(grandchild)}})</div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default
{
    name: 'OutrightsMenuTreeItem',
    props: ['treeItem', 'countOutrights'],
    methods: {
        ...mapActions({
            selectOutright: 'selectOutright',
            updateTreeItem: 'updateTreeItem',
        }),
        goTo(treeItemId)
        {
            const me = this;
            me.$emit('goFurther', String(treeItemId));
            me.$emit('selectOutright', {
                outrightId: null,
                eventType: 'outrights',
                push: true,
            });
        },
        goFurther(treeItemId, val)
        {
            const me = this;
            me.$emit('goFurther', `${treeItemId},${val}`);
        },
    },
};
</script>
